<template>
  <v-sheet>
    <base-grid
      badgeIcon="mdi-close"
      badgeColor="red"
      :ids="badgeIds"
      :items="learningItems"
      :imageUrls="imageUrls"
      v-on:grid:badge:click="
        $router.push({
          name: 'learningItemManager',
          params: { id: $event.id },
          query: { edit: true }
        })
      "
      v-on:grid:badge:action:click="deleteItem($event.id)"
      gridId="js-learning-items-grid"
    />
  </v-sheet>
</template>
<script>
import eventMixin from "@/mixins/eventMixin"
import BaseGrid from "@/components/BaseGrid"

export default {
  mixins: [eventMixin],
  components: {
    BaseGrid
  },
  props: {
    courseId: { type: Number }
  },
  computed: {
    badgeIds() {
      return this.learningItems.map(
        (el, index) => `js-learning-item-grid-${index + 1}`
      )
    },
    imageUrls() {
      return this.learningItems.map(el => el.badge_url)
    },
    learningItems() {
      let course = this.$store.getters["courses/getCourseById"](this.courseId)
      return course ? course.learning_items : []
    }
  },
  methods: {
    deleteItem(id) {
      if (confirm("Are you sure you want to delete this? OK to delete.")) {
        this.$store.dispatch("learningItems/deleteLearningItem", id)
      }
    }
  }
}
</script>
